import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

import { ProductCategoryIcon } from "./types/ProductCatgeoryIcon"

export const ProductCategoryObjClass = Scrivito.provideObjClass(
  "ProductCategory",
  {
    attributes: {
      ...defaultPageAttributes,
      icon: ["enum", { values: Object.values(ProductCategoryIcon) }],
      breadcrumbWidget: ["widgetlist", { only: "BreadcrumbWidget" }],
      isHiddenInPortfolio: "boolean",
      showBuildingTypeFilter: "boolean",
      showRoomTypeFilter: "boolean",
      childOrder: "referencelist"
    },
    onlyChildren: ["ProductGroup"]
  }
)

export type ProductCategoryObj = InstanceType<typeof ProductCategoryObjClass>
export type ProductCategoryAttributes = ScrivitoAttributes<ProductCategoryObj>
